import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';

// API
import * as API  from '../../../../utils/api';

// Components
import FormContainer from '../../../../components/Global/FormContainer';
import LockerVideosForm from './LockerVideosForm/LockerVideosForm';
import LockerPhotosManager from './LockerPhotosManager/LockerPhotosManager';

// Flash Message Component
import FlashMessage from '../../../../components/Global/FlashMessage';

class LockerPhotoVideo extends Component {
  static propTypes = {
    updateParticipation: PropTypes.func.isRequired,
    participation: PropTypes.object
  }

  state ={
    isLoading: true,
    flashMessage: {
      type: '',
      message: '',
    },
    displayFlashMessage: false,
  }

  componentWillReceiveProps(nextProps) {
    nextProps.participation && this.setState({isLoading: false})
  }

  handleSubmit = (values) => {
    const { user, participation } = this.props

    API.updateParticipation(user, participation, values)
    .then(response => {
      window.scrollTo(0, 0)
      if (response.status === 200) {
        this.setFlashMessage('', 'Changes saved successfully', true)
      } else {
        this.setFlashMessage('error', `Error: ${response.message}`, true)
      }
    })
  }

  setFlashMessage = (type, message, display) => {
    this.setState({
      flashMessage: {
        type,
        message
      },
      displayFlashMessage: display
    })
  }

  renderFlashMessage() {
    const {
      displayFlashMessage,
      flashMessage
    } = this.state;

    return displayFlashMessage
    ? (
      <FlashMessage optionalClasses={flashMessage.type === 'error' ? 'error' : ''}>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  render() {
    const { isLoading } = this.state
    const { participation, updateParticipation } = this.props
    const { trial_active, on_trial } = this.props.activeProfile.trial_info
    const isLocked = on_trial && !trial_active

    return isLoading
    ? null
    : (
      <FormContainer optionalClassName="locker-photo-video" isLocked={isLocked}>
        {this.renderFlashMessage()}
        <header>
          <h2>Photos</h2>
          <LockerPhotosManager
            participation={participation}
            updateParticipation={updateParticipation}
            setFlashMessage={this.setFlashMessage}
          />
        </header>
        <header>
          <h2>Videos</h2>
          <p className="note">
            Hudl or YouTube links only. To find the link, navigate to the video, and copy and paste the URL from the browser window.
          </p>
          <p className="note">
            For example: <code>https://www.hudl.com/video/3/1623268/5721b1e24df6124b70ed5743</code>
            <br/>
            or:
            <br/>
            <code>https://www.youtube.com/watch?v=aBc123Def45</code>
          </p>
          <p className="note">
             You can also use a YouTube share link:
             <br/>
             <code>https://youtu.be/aBc123Def45</code>
          </p>
        </header>
        <LockerVideosForm
          onSubmit={this.handleSubmit}
          participation={participation}
        />
      </FormContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

export default connect(
  mapStateToProps,
  null
)(LockerPhotoVideo)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerPhotoVideo.js